import { createEffect } from "solid-js"
import { useLocation, useNavigate } from "@solidjs/router"
import { persistAuthSignInReturnTo } from "./sign-in-return-to"

export function AuthSignInAlias() {
  const location = useLocation()
  const navigate = useNavigate()
  createEffect(() => {
    persistAuthSignInReturnTo(location.search)
    navigate("/login", { replace: true })
  })
  return null
}
